import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultConversionInfo } from '../interfaces/ConversionIf' // 返却型が無ければ ResultWordInfo に準拠
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface CB04ConversionUpdateProps {
  execConversionUpdate: (
    deviceId: string,
    oldPreText: string,
    newPreText: string,
    newPostText: string
  ) => Promise<ResultConversionInfo>
  loading: loadStatus
}

export const useCB04ConversionUpdate = (): CB04ConversionUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()

  const execConversionUpdate = async (
    deviceId: string,
    oldPreText: string,
    newPreText: string,
    newPostText: string
  ): Promise<ResultConversionInfo> => {
    try {
      setLoading(loadStatus.LOADING)

      const jwt = await auth.getJwt()
      if (!jwt) {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const headers = {
        ...axiosDefaultHeader,
        Authorization: `Bearer ${jwt}`,
      }

      const body = {
        old_pre_text: oldPreText,
        pre_text: newPreText,
        post_text: newPostText,
      }
      const response = await axios.put(
        buildDeviceUrl(deviceId, apiUrl.conversionsPath),
        body,
        {
          headers,
          validateStatus: () => true,
        },
      )
      setLoading(loadStatus.LOADED)

      if (response.status === apiStatus.SUCCESS) {
        return { success: true, info: response.data }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execConversionUpdate, loading }
}